// Note: all function here should end with "FeatureFlag" so it's easy to identify any where they are used.
// All feature flags should be short term and removed once the feature is fully signed-off on and/or implemented.
// Current case is purely for internal business and PM sign-off. Who can be instructed how to enable/disable the features.

// Do not make dynamic - intended use is manual edit in localstorage, refresh the page, and see effect.
import posthog from "posthog-js";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isVitest =
  typeof process !== "undefined" && process.env.VITEST === "true";

// Read flag url params and load.
const urlParams = new URLSearchParams(globalThis.location.search);
const flagsParam = urlParams.get("flags");

const ORDER_BOOK_BARS_ENABLED = "order-book-bars-enabled";
const MOCK_SERVER = "mock-server";
const CLEARBANK = "clearbank";
const ADVANCED_MOBILE_VIEW = "advanced-mobile-view";

const VALID_URL_FLAGS = [
  ORDER_BOOK_BARS_ENABLED,
  MOCK_SERVER,
  CLEARBANK,
  ADVANCED_MOBILE_VIEW,
];
const POSTHOG_FLAGS = [ORDER_BOOK_BARS_ENABLED, CLEARBANK];

// Do not read flags URL and Posthog flags, it's one or the other.
// If someone is adding flags to the URL, they are likely internal.
if (flagsParam) {
  for (const flag of flagsParam.split(";")) {
    const [key, value] = flag.split(":");
    if (!VALID_URL_FLAGS.includes(key)) continue;
    if (key && value) {
      if (value === "1" || (value === "0" && VALID_URL_FLAGS.includes(key))) {
        localStorage.setItem(key, value);
      }
    }
  }
} else {
  try {
    posthog.onFeatureFlags(() => {
      for (const flag of POSTHOG_FLAGS) {
        const enabled = posthog.isFeatureEnabled(flag);
        if (enabled === undefined) {
          console.log(
            `WARNING: Feature flag is not available or has been removed from posthog: ${flag}`,
          );
          continue;
        }
        localStorage.setItem(flag, enabled ? "1" : "0");
      }
    });
  } catch (e) {
    console.error(e);
  }
}

const orderBookBarsEnabled =
  isVitest || localStorage.getItem(ORDER_BOOK_BARS_ENABLED) === "1";

const mockServerEnabled = isVitest || localStorage.getItem(MOCK_SERVER) === "1";

const clearbankEnabled = isVitest || localStorage.getItem(CLEARBANK) === "1";

const advancedMobileView =
  isVitest || localStorage.getItem(ADVANCED_MOBILE_VIEW) === "1";

export const featureFlags = {
  orderBookBarsEnabled,
  mockServerEnabled,
  clearbankEnabled,
  advancedMobileView,
};
